import React from 'react';
import { Tabs } from 'antd';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import OpenAiUsageReport from './OpenAiUsageReport';
import UsersManagement from './UsersManagement';

const Container = styled.div`
    padding: 24px;
    background-color: ${COLOR.white};
    min-height: calc(100vh - 200px);
`;

const SuperAdminControlPanel = () => {
    return (
        <Container>
            <h1 style={{ marginBottom: 24, fontSize: 28, fontWeight: 600 }}>
                Super Admin Control Panel
            </h1>
            <p style={{ marginBottom: 24, color: '#666', fontSize: 14 }}>
                Manage super admin users. Root super admins can manage other super admins, their permissions, and security settings.
            </p>
            <Tabs
                defaultActiveKey="users"
                items={[
                    {
                        key: 'users',
                        label: 'Users',
                        children: <UsersManagement />,
                    },
                    {
                        key: 'openai_usage',
                        label: 'OpenAI usage',
                        children: <OpenAiUsageReport />,
                    },
                ]}
            />
        </Container>
    );
};

export default SuperAdminControlPanel;
